import { ProgressSpinner } from 'primereact/progressspinner';
import { HourlyScheduleByRoomData } from './hourlyScheduleByRoom.types';
import classes from './hourlyScheduleByRoom.module.scss';
import { useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

interface HourlyScheduleByRoomTableProps {
  hourlyScheduleByRoomData: HourlyScheduleByRoomData[];
  loading: boolean;
}

const HourlyScheduleByRoomTable = ({
  hourlyScheduleByRoomData,
  loading
}: HourlyScheduleByRoomTableProps) => {
  // Get all unique time slots from the first data entry (assuming all have the same slots)
  const timeSlots = useMemo(() => {
    if (hourlyScheduleByRoomData.length === 0) {
      return [];
    }
    return Object.keys(hourlyScheduleByRoomData[0].hourly_jobs);
  }, [hourlyScheduleByRoomData]);

  // Prepare table data: flatten hourly_jobs into top-level keys for DataTable
  const tableData = useMemo(() => {
    return hourlyScheduleByRoomData.map(room => ({
      room_name: room.room_name,
      ...room.hourly_jobs
    }));
  }, [hourlyScheduleByRoomData]);

  if (loading === true) {
    return (
      <div className={classes.loadingContainer}>
        <ProgressSpinner className={classes.spinner} />
        <div>Loading Hourly Schedule By Room data...</div>
      </div>
    );
  }

  return (
    <div className={classes.hourlyScheduleByRoomTableContainer}>
      <div className={classes.tableWrapper}>
        <DataTable
          value={tableData}
          emptyMessage="No records found"
          className={classes.dataTable}
          rowClassName={() => classes.tableRow}
          resizableColumns
          scrollable
          scrollHeight="flex"
          loading={loading}
          columnResizeMode="expand"
          stripedRows={true}
        >
          <Column
            field="room_name"
            header="Time"
            frozen
            bodyClassName={classes.stickyColumn}
            style={{ minWidth: 160, maxWidth: 200 }}
          />
          {timeSlots.map(slot => (
            <Column
              key={slot}
              field={slot}
              header={slot}
              bodyClassName={classes.columndata}
              style={{ minWidth: 180, maxWidth: 340 }}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default HourlyScheduleByRoomTable;
